module.exports = "/dist/assets/fonts/TTCommons-Medium.woff2";